import '.r{flex:1;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.af{align-items:start;}.ssr-plugin'
import '.d2{gap:8px;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.a8{gap:4px;}.ssr-plugin'
import { ReactNode } from 'react'
import { Text } from '../Text/index.js'
import { colors } from '../../tokens/colors.js'
import { Icon } from '../Icon/index.js'
import { Note, NoteProps } from '../Note/index.js'
import { styled } from 'inlines'

type FormFieldProps = {
  label?: string
  description?: string
  error?: string
  children: ReactNode
  note?: Pick<NoteProps, 'title' | 'description'>
}

function FormField({
  children,
  label,
  description,
  error,
  note,
}: FormFieldProps) {
  return (
    <div className="r f a i af d2"
    >
      {label && (
        <Text variant="subtext-regular" color="neutral60">
          {label}
        </Text>
      )}
      <div className="f">{children}</div>

      {error && (
        <div className="a d a8"
          style={{
            color: colors.red100,
          }}
        >
          <Icon variant="error-filled" color="red100" />
          <Text color="inherit" variant="display-medium">
            {error}
          </Text>
        </div>
      )}
      {description && (
        <Text variant="display-regular" color="neutral60">
          {description}
        </Text>
      )}
      {note && <Note {...note} />}
    </div>
  )
}

export { FormField }
export type { FormFieldProps }
